import { Output, Component, OnInit, ViewContainerRef } from '@angular/core';
import { AppSettings, PaymentType, enumStatusCodeList } from '../../../sharedcomponents/_common/constants/app.constants';
import { CartServiceService } from '../../../_services/dashboardservice/cart/cart-service.service';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { ShoppingcartsummaryComponent } from '../shoppingcartsummary/shoppingcartsummary.component';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
import { SendMoneyDetail } from '../../../models/sendmoney/sendmoney';
import { ErrorPopupComponent } from '../../../sharedcomponents/_directive/error-popup/error-popup.component';
import { currentcartdetail, ShopingCart, ShopingCartList } from '../../../models/dashboard/cart/mywallet.currentcart.Modal';
import { UserGioLocation } from '../../../models/user/usergioLocation';
import { userGioLocationService } from '../../../_services/UserService/user.giolocation.service';
import { PaymentreceiptService } from '../../../_services/paymentreceipt/paymentreceipt.service';
import { mywalletstore } from '../../../_services/mywallet/store/mywallet.store.service';
import { Subject } from 'rxjs';
import { uploaddocumtuserprofilestep1 } from '../../../user/user-register/user-document-upload/userprofile-document-upload.component-Step1';
import { uploaddocumtuserprofilestep2 } from '../../../user/user-register/user-document-upload/userprofile-document-upload.component-Step2';
import { geolocation } from '../../../sharedcomponents/commonservice/geolocation/geoloc';
import { ValidateTMService } from '../../../sharedcomponents/commonservice/TmValidation/tmvalidation.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../../../_services/userservice/auth.service';
import { AlertPopupComponent } from '../../..//sharedcomponents/_directive/alert-popup/alert-popup.component';
import { UserProfileTMNIovation, enumEventype } from '../../../models/user/user.tm.profile.model';
import { User } from '../../../models/user/user';
import { UserStateService } from '../../../_services/userservice/userstateservice';

import { ThreatMetrixService } from '../../../_services/ThreatMetrix/threatmetrix'

@Component({
  selector: 'app-shoppingcartlist',
  templateUrl: './shoppingcartlist.component.html',
  styleUrls: ['./shoppingcartlist.component.css'],
  providers: [AlertService, CartServiceService, Modal, ValidateTMService, AuthService, ThreatMetrixService]
})
export class ShoppingcartlistComponent implements OnInit {
  dispalycartlist: any;
  userData: User;
  cartresponse: any;
  cartcode = 0;
  sumofcart = 0.0;
  countofcart = 0.0;
  fundingID = '';
  cartcodeisvisible = false; // Cart Code will show only in case of store
  shoppingcartpaymetbuttoncaption = '';
  sendMoneyDetail: SendMoneyDetail;
  storeList: any = [];
  reqObj: any = {};
  shopingCart: ShopingCart;
  storeId = [];
  unsubDocReq: any;
  DocumentRequired: {};
  userProfileTMNIovation: UserProfileTMNIovation;
  private subDocReq = new Subject<boolean>();
  fraudDetectionPromise: Promise<any>;
  @Output()
  observableDocReq = this.subDocReq.asObservable();
  private subProfile = new Subject<boolean>();
  @Output()
  subProfileObservable = this.subProfile.asObservable();
  curcarddetailresponsemodel: any;
  constructor(
    private sendMoneyService: SendMoneyService,
    private cartservice: CartServiceService,
    private alertService: AlertService,
    public utilserv: utilityService,
    private translate: TranslateService,
    private userGioLocationSer: userGioLocationService,
    public modal: Modal,
    private router: Router,
    private paymentreceipt: PaymentreceiptService,
    private storeservice: mywalletstore,
    private geoloc: geolocation,
    private tmValidateService: ValidateTMService,
    private vcRef: ViewContainerRef,
    private auth: AuthService,
    private userStateService: UserStateService,
    private threatMetrixService: ThreatMetrixService
  ) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const userStateServiceSub = this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userData = new User();
      this.userData = data;
      if (userStateServiceSub != undefined) {
        userStateServiceSub.unsubscribe();
      }
    });
  }

  ngOnInit() {
    // this.shoppingcartpaymetbuttoncaption = this.translate.instant('Cart_btnPayNow');
    this.shoppingcartpaymetbuttoncaption = 'Cart_btnPayNow';
    // this.cartservice.getcurrentcartDetailDashBoardData().subscribe(data => {
    //               this.reqObj.fundingId = data.FundingId;
    //    });
    this.reqObj.userGioLocation = new UserGioLocation();
    this.userGioLocationSer.getserGioLocation().subscribe(data => {
      this.reqObj.userGioLocation = data;
    });
    this.curcarddetailresponsemodel = new currentcartdetail();
    this.getcarttype(this.curcarddetailresponsemodel);
    this.threatMetrixService.Init();
  }

  getcartlist() {
    this.utilserv.busy = this.cartservice.getcartlistservice().subscribe(data => {
      this.countofcart = 0;
      this.sumofcart = 0;
      if (data.Envelope.Body.GetCartItemResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
        return false;
      }
      if (data.Envelope.Body.GetCartItemResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        this.cartcode = this.utilserv.getObjectText(data.Envelope.Body.GetCartItemResponse.CartCode);

        this.cartresponse = this.utilserv.getArray(data.Envelope.Body.GetCartItemResponse.Items.CartItem);
        this.reqObj.shopingCartList = new Array<ShopingCart>();
        this.cartresponse.forEach(element => {
          this.sumofcart += Number(this.utilserv.getObjectText(element.TotalAmount));
          this.shopingCart = new ShopingCart();
          this.shopingCart.itemId = this.utilserv.getObjectText(element.ItemId);
          this.reqObj.shopingCartList.push(this.shopingCart);
          this.fundingID = this.utilserv.getObjectText(element.FundingId);
          if (this.utilserv.getObjectText(element.StoreId) > 0) {
            this.storeId.push(this.utilserv.getObjectText(element.StoreId));
          }
        });

        this.countofcart = this.cartresponse.length;
        this.reqObj.CurrencyFrom = this.utilserv.getObjectText(this.cartresponse[0].CurrencyCodeFrom);
        this.reqObj.totalAmount = this.sumofcart.toFixed(AppSettings.fractionDigit);
        this.paymentreceipt.setCartReceiptData(this.cartresponse);
        // If fundding ID is available then it's through debit card else pay at store

        if (Number(this.fundingID) === 0 && this.storeId.length > 0) {
          this.cartcodeisvisible = true;
          // this.shoppingcartpaymetbuttoncaption = this.translate.instant('AgentLocator_title');
          this.shoppingcartpaymetbuttoncaption = 'AgentLocator_title';
        }
      } else if (data.Envelope.Body.GetCartItemResponse.StatusCode == '10028') {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        // no data found
        const self = this;
        const modalData: any = {};
        modalData.Title = this.translate.instant('Common_lblInfo').toString();
        modalData.Message = data.Envelope.Body.GetCartItemResponse.StatusMessage;
        modalData.Action = this.translate.instant('CartEmptyPopup_btnGoToDashboard');
        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(error => {
            self.router.navigate(['/dashboard']);
            // this.ngOnInit();
          });
        });
      }
    });
  }

  opencartsummary(element) {
    const parent = this;
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal.open(ShoppingcartsummaryComponent, overlayConfigFactory({ element }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        parent.ngOnInit();
      });
    });
  }

  // this method will Pay the cart amount

  validatePaymentDocument() {
    this.isdocumentRequiredCheck();
    this.unsubDocReq = this.observableDocReq.subscribe(isDocumentRequired => {
      if (isDocumentRequired == false) {
        if (this.cartcodeisvisible === false) {
          this.pay(); // Debit Card Payment
        } else {
          this.getstorelist(); // Store List Payment
        }
        // Do Final Payment
      } else if (isDocumentRequired == true) {
        this.uploadDocument();
      } else {
        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
      }
      if (this.unsubDocReq != undefined) {
        this.unsubDocReq.unsubscribe();
      }
    });
  }
  pay() {
    this.reqObj.fundingId = this.fundingID;
    this.utilserv.busy = this.geoloc.getGioLocation().subscribe(data => {
      this.geoloc.setserGioLocation(data)
      this.reqObj.userGioLocation = data;
      this.utilserv.busy = this.cartservice.payShopingCart(this.reqObj).subscribe(
        data => {
          if (data.Envelope.Body.PaymentResponse.StatusCode == -10000) {
            this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
          } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
            return false;
          } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.SUCCESS) {
            this.router.navigate(['/PaymentReceiptDebitcard']);
            // this.router.navigate(['/PaymentReceipt']);
            return;
          } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.Transactioninprocess) {
            this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblTransactionInProcess'));
          } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.Transactionnotfound) {
            this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblTransactionNotFound'));
          } else if (data.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.OutOfAreaOfService) {
            this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Common_lblLocationValidate'));
          } else {
            this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('AddToCartFailure_paymentFailDesc'));
          }
        },
        error => {
          // this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('AddToCartFailure_paymentFailDesc'));
        }
      );
    });
  }
  getstorelist() {
    this.router.navigate(['/agentlocator']);
    return;
  }
  getcarttype(curcarddetailresponsemodel: currentcartdetail) {
    this.cartservice.getcarttypeservice().subscribe(
      data => {
        this.getcartlist();
        if (data.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
          return false;
        }
        if (data.StatusCode == enumStatusCodeList.SUCCESS) {
          curcarddetailresponsemodel.CartExpiry = this.utilserv.getObjectText(data.CartExpiry);
          curcarddetailresponsemodel.CustmerPaymentMethod = this.utilserv.getObjectText(data.CustmerPaymentMethod);
          // CustmerPaymentMethod-10,30 30-Debit card 10- Store
          curcarddetailresponsemodel.FundingId = this.utilserv.getObjectText(data.FundingId);
          curcarddetailresponsemodel.GuaranteedCancellationPeriod = this.utilserv.getObjectText(data.GuaranteedCancellationPeriod);
          curcarddetailresponsemodel.ItemCount = this.utilserv.getObjectText(data.ItemCount);
          curcarddetailresponsemodel.StoreId = this.utilserv.getObjectText(data.StoreId);
          curcarddetailresponsemodel.StoreName = this.utilserv.getObjectText(data.StoreName);
          curcarddetailresponsemodel.SuperSend = this.utilserv.getObjectText(data.SuperSend);
          curcarddetailresponsemodel.UnReadMessageCount = this.utilserv.getObjectText(data.UnReadMessageCount);
          this.cartservice.setcurrentcartDetailDashBoardData(curcarddetailresponsemodel);
          this.sendMoneyService.setcurrentcartDetailData(curcarddetailresponsemodel);
        }
      },
      error => {}
    );
  }
  // Document Required-Functionality need ro move to service

  isdocumentRequiredCheck() {
    // some code here

    let reqObj: any;
    this.utilserv.busy = this.sendMoneyService.documentRequiredCheck().subscribe(data => {
      if (data.Envelope.Body.DocumentRequiredResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
        return false;
      }
      if (data.Envelope.Body.DocumentRequiredResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        if (
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxID == 'true' ||
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxIdForUSID == 'true' ||
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerID == 'true'
        ) {
          this.DocumentRequired = data.Envelope.Body.DocumentRequiredResponse;
          this.subDocReq.next(true);
        } else {
          this.subDocReq.next(false);
        }
      } else {
        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
      }
    });
  }

  uploadDocument() {
    const _self = this;
    const modalData: any = {};
    this.modal.overlay.defaultViewContainer = this.vcRef;

    modalData.DocumentRequired = this.DocumentRequired; 
    this.modal.open(uploaddocumtuserprofilestep1, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.Status == false) {
          return;
        }
        if (modalData.Status == true) {
          modalData.Status = false;
          const docData = modalData;
          _self.modal.overlay.defaultViewContainer = _self.vcRef;

          return _self.modal.open(uploaddocumtuserprofilestep2, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              _self.modal.overlay.defaultViewContainer = _self.vcRef;
              if (modalData.Status == false) {
                return;
              }
              if (modalData.Status == true) {
                if (_self.cartcodeisvisible === false) {
                  _self.pay(); // Debit Card Payment
                } else {
                  _self.getstorelist(); // Store List Payment
                }
              } else {
                _self.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
              }
            });
          });
        } else {
          _self.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
        }
      });
    });
  }
  errorPopup(title, message) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    let modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  // Geo Location Check
  geoGraphicalCheck() {
    const _self = this;
    if (this.cartcodeisvisible) {
      this.getstorelist(); // Store List Payment
      return;
    }
    this.modal.overlay.defaultViewContainer = this.vcRef;
    this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(
      data => {
        if (data == undefined) {
          return;
        }
        if (data == true) {
          _self.userProfileTMNIovation = new UserProfileTMNIovation();
          _self.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
          _self.userProfileTMNIovation.eventType = enumEventype[enumEventype.Payment];
          _self.userProfileTMNIovation.transactionAmount = _self.reqObj.totalAmount;
          _self.userProfileTMNIovation.transactionCurrency = _self.reqObj.CurrencyFrom;
          if (_self.reqObj.shopingCartList[0].itemId != undefined) {
            _self.userProfileTMNIovation.transactionId = _self.reqObj.shopingCartList[0].itemId;
          }
          _self.userProfileTMNIovation.userProfile = _self.userData;

          if (!_self.fraudDetectionPromise) {

            _self.fraudDetectionPromise = new Promise((resolve, reject) => {
    
              _self.threatMetrixService.Profile().then(sessionId => {
                _self.userProfileTMNIovation.deviceProfile.SessionID = sessionId;
                _self.utilserv.busy = _self.auth.profileTMnIovation(_self.userProfileTMNIovation).subscribe(data => {

                  if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
                    resolve(data);
                  } else {
                    reject(data);
                  }
                });
              });
            });
         }

         this.fraudDetectionPromise.then(data => {
          _self.validatePaymentDocument();
         }, errorData => {
          _self.errorPopup(this.translate.instant('Common_lblInfo'), _self.translate.instant('Message_errorMessage'));
         });

        } else {
          _self.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_areaPermissibleError'));
        }
      },
      error => {}
    );
  }
}
class cartdetail {
  cardlastfournum = '';
  cardfriendlyName = '';
  cardimageurl = '';
}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/shoppingcartlist/shoppingcartlist.component.ts